import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import ko from './locales/ko.json';
import en from './locales/en.json';

const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'ko' ? 'ko' : browserLang === 'en' ? 'en' : 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: es
      },
      ko: {
        translation: ko
      },
      en: {
        translation: en
      }
    },
    lng: getBrowserLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;

